module.exports = __webpack_public_path__ + "3da295cc1337e85be473df4214158f46.pdf";